import React, { useContext, useState } from 'react';
import {Context} from '../../services/contexts/StateContext';
import * as S from './styles';
import editar from '../../midia/editar.svg';
import delet from '../../midia/delete.svg';
import Ativar from '../../midia/ativar.svg';
import Pendente from '../../midia/cancelar.svg';
import api from '../../services/api';
import Cookies from 'js-cookie';

import {AlertComp} from '../../componentes/alerte/index';

//-----------------------------------------------
export const ListaUsuario = (props) => {
    const {state, dispatch} = useContext(Context);
    const {usuario, logado} = state.cliente;
    const {parametroInit, playmodal, playLista, listaPesquisa} = state.parametros;
    const {playListaUsuario} = playLista;
    const [filtroStatus, setFiltroStatus] = useState('');

    // Usuários antigos sem status são considerados ativos
    const listaFiltrada = (props.listaBusca || []).filter(t =>
        !filtroStatus || (t.status || 'A') === filtroStatus
    );

//---------------------------------------------------
function lixeira(t){
    dispatch({
        type: 'set_usuario',
        payload:{...usuario, 'id_Usuario':t._id}
    });
    props.setAletDelete(true);
    props.setNewStatus('E');
    props.setRefDelet("usuario");
};
//-----------------------------------------------
async function alterarStatus(t, status = 'A'){
    try {
        if (t.status === 'P' && status === 'A') {
            await api.put(`/usuario/aprovar/${t._id}`, {}, {
                headers: { Authorization: `Bearer ${Cookies.get('token')}` }
            });
        } else {
            await api.put(`/usuario/status/${t._id}`, { status }, {
                headers: { Authorization: `Bearer ${Cookies.get('token')}` }
            });
        }
        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                listaUsuario: (listaPesquisa.listaUsuario || []).map(item =>
                    item._id === t._id ? { ...item, status } : item
                ),
            }
        });
    } catch (error) {
        alert(error.response?.data?.error || 'Não foi possível alterar o status do usuário.');
    }
};
const ativarEste = (t) => alterarStatus(t, 'A');

//---------------------------------------------------
function detalhe(t){
    dispatch({
        type: 'set_usuario',
        payload:
        {
            ...usuario, 
            id_Usuario:t._id,
            cpf:t.cpf,
            nome:t.nome,
            email:t.email,
            senha:t.senha, 
            id_Franquia:t.id_Franquia,  
        }
    });
    dispatch({
        type:'SET_parametroInit',
        payload: {
            ...parametroInit, 
            detalhesLista:true,
            detalhesModal: true, 
            pesquisaIdUsuario:true,
            disabled:true
        }
    });

    dispatch({
        type:'SET_PLAYMODAL',
        payload: {...playmodal, playModalUsuario: true}
    });
};

//###################################################################
    const iconeStyle = { flex: '0 0 16px', width: '16px', height: '16px', margin: 0, objectFit: 'contain' };

    return(
        <div style={{'display':"flex", "flexDirection":"column"}}> 
            {playListaUsuario && props.listaBusca.length > 0 && 
            <>
            <S.bodyTitulo>
                <div className={'titulo'}>
                    <div className={'tituloUser'}>
                        {props.titulo}
                    </div>
                </div>
            </S.bodyTitulo>
            
            <S.bodyresult style={{ maxWidth: '900px' }}>
                <div style={{ display: 'flex', gap: '6px', margin: '4px 0', flexWrap: 'wrap' }}>
                    {[['', 'Todos'], ['A', 'Ativo'], ['P', 'Pendente'], ['E', 'Excluído']].map(([valor, rotulo]) => (
                        <button
                            key={valor}
                            type='button'
                            onClick={() => setFiltroStatus(valor)}
                            style={{
                                padding: '3px 12px',
                                border: '1px solid #00c27a',
                                borderRadius: '14px',
                                cursor: 'pointer',
                                fontSize: '12px',
                                background: filtroStatus === valor ? '#00c27a' : 'transparent',
                                color: filtroStatus === valor ? '#fff' : '#00c27a',
                            }}
                        >
                            {rotulo}
                        </button>
                    ))}
                </div>

                {props.alertDelete && 
                <AlertComp
                alertDescrit={'Deseja mesmo Excluir?'}
                seSim={props.ExcluirEste}
                seNao={props.FecharAlerte}
                />
                }

                {listaFiltrada.length === 0 &&
                    <span style={{ padding: '8px', color: '#888' }}>Nenhum usuário com este status.</span>
                }

                {listaFiltrada.map((t, k) => (
                <S.Lista key={t._id || k} statusPend={t.status === 'E'}>
                    <span title={t.nome} style={{ textTransform: 'capitalize', flex: '2 1 0', minWidth: 0 }}>{t.nome}</span>
                    <span title={t.email} style={{ flex: '3 1 0', minWidth: 0 }}>{t.email}</span>
                    <span style={{ flex: '0 0 60px', textTransform: 'capitalize', fontWeight: 600 }}>
                        {t.nivel || 'usuario'}
                    </span>
                    <span style={{ flex: '0 0 55px', color: '#9a5b00', fontSize: '11px' }}>
                        {t.status === 'P' ? 'Pendente' : ''}
                    </span>
                
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '6px', flex: '0 0 78px', width: '78px', paddingLeft: '4px' }}>
                    <img 
                    className='icone'
                    src={editar} 
                    style={iconeStyle}
                    onClick={()=>detalhe(t)} 
                    alt="Editar usuário"
                    title="Editar usuário"
                    />

                    {t.status !== 'E' && logado.nivel === 'master' &&
                    <img 
                    className='icone'
                    src={delet} 
                    style={iconeStyle}
                    onClick={()=>lixeira(t)} 
                    alt="Excluir usuário"
                    title="Excluir usuário"
                    />
                    }
                
                    {logado.nivel === 'master' && (t.status === 'E' || t.status === 'P') &&
                    <img 
                    className='icone'
                    src={Ativar} 
                    style={iconeStyle}
                    onClick={()=>ativarEste(t)} 
                    alt={t.status === 'P' ? 'Aprovar usuário' : 'Ativar usuário'}
                    title={t.status === 'P' ? 'Aprovar cadastro' : 'Ativar usuário'}
                    />
                    }

                    {logado.nivel === 'master' && t.status !== 'P' && t.status !== 'E' && String(t._id) !== String(logado.idLogado) &&
                    <img 
                    className='icone'
                    src={Pendente} 
                    style={iconeStyle}
                    onClick={()=>alterarStatus(t, 'P')} 
                    alt='Marcar como pendente'
                    title='Marcar como pendente'
                    />
                    }
                    </div>

                </S.Lista>
                ))}
            </S.bodyresult>
            </>}
        </div>
    
)}